export default __webpack_public_path__ + "static/media/stairsToSuccess.dab5eedc.webp";